/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import { useI18n } from "hooks/i18n/i18n";
import { changeStyleWithHosting } from "utility/hosting";

import type { FC } from "react";

export const ResaleApplicationCompletionMessage: FC = () => {
  const { t } = useI18n();
  const classes = styles();

  return (
    <section css={classes.root}>
      <CheckCircleOutlineIcon css={classes.icon} aria-hidden="true" />
      <h2 css={classes.title}>
        {t("event.resale.entry.completion.acceptedTitle")}
      </h2>
      <p css={classes.description}>
        {t("event.resale.entry.completion.acceptedDescription")}
      </p>
    </section>
  );
};

const styles = () => {
  const { accentColor } = changeStyleWithHosting().baseStyles;

  return {
    root: css`
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;
      padding-top: 24px;
      text-align: center;
    `,
    icon: css`
      color: ${accentColor};
      font-size: 64px;
    `,
    title: css`
      margin: 0;
      font-size: 20px;
      font-weight: bold;
      line-height: 1.5;
      @media screen and (min-width: 768px) {
        font-size: 24px;
      }
    `,
    description: css`
      margin: 0;
      color: #666;
      font-size: 12px;
      line-height: 1.75;
      @media screen and (min-width: 768px) {
        font-size: 14px;
      }
    `,
  };
};
